export default __webpack_public_path__ + "static/media/hor-cart.1b856ec5.png";